<script>
  /* Copyright 2019 Google LLC All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  ==============================================================================*/

  import Slider from "../../../shared/components/Slider.svelte";

  export let options;
  export let value;
  export let onChange = () => {};

  const { name, min, max } = options;
  const step = options.step || 1;
</script>

<style>
  .slider-container {
    margin: 10px 0;
  }
</style>

<div>
  <span>{name}</span>
  <span>{value}</span>
  <div class="slider-container">
    <Slider {min} {max} {step} bind:value {onChange} />
  </div>
</div>
